import { connect } from 'react-redux'
import NoGroups from './no-groups'
import { openAddGroupDialog } from '../dialogs/add-group/add-group.actions'

const mapDispatchToProps = dispatch => ({
  onAddGroup: () => dispatch(openAddGroupDialog())
})

export default connect(
  null,
  mapDispatchToProps
)(NoGroups)
